<template>
    <v-col cols="12" class="pa-1" ref="item">
        <template v-if="message.type == CHAT_MESSAGE_TYPES.PROMPT_ALERT.value">
            <item-alert v-bind="{ messages, message }" />
        </template>
        <template v-if="message.type == CHAT_MESSAGE_TYPES.PROMPT_QUERY.value">
            <item-query v-bind="{ messages, message, index }" />
        </template>
        <template v-if="message.type == CHAT_MESSAGE_TYPES.PROMPT_REPLY.value">
            <item-reply v-bind="{ messages, message, index }" />
        </template>
    </v-col>
</template>

<script>
import { CHAT_MESSAGE_TYPES, initChatMessage } from "@/store/chat";

import ItemAlert from "./item/item-alert.vue";
import ItemQuery from "./item/item-query.vue";
import ItemReply from "./item/item-reply.vue";

export default {
    components: {
        ItemAlert,
        ItemQuery,
        ItemReply,
    },
    props: {
        messages: { type: Array, default: () => [] },

        index: { type: Number, default: 0 },
        message: { type: Object, default: initChatMessage },
        isScrollFixed: { type: Boolean, default: false },
    },
    data: () => ({
        CHAT_MESSAGE_TYPES,
    }),
    methods: {
        scroll() {
            if (this.isScrollFixed) {
                this.$nextTick(() => {
                    const intervalId = setInterval(() => {
                        const el = this.$refs["item"];
                        if (!el) return;
                        this.$emit("scroll");
                        clearInterval(intervalId);
                    }, 10);
                });
            }
        },
    },
    watch: {
        message() {
            this.scroll();
        },
    },
    mounted() {
        this.scroll();
    },
};
</script>

<style></style>
